"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function isNullString(value) {
    return lodash_1.toLower(value) === 'null';
}
exports.isNullString = isNullString;
function isUndefinedString(value) {
    return lodash_1.toLower(value) === 'undefined';
}
exports.isUndefinedString = isUndefinedString;
function isNilString(value) {
    return lodash_1.toLower(value) === 'null' || value === 'undefined';
}
exports.isNilString = isNilString;
function isBooleanString(value) {
    if (lodash_1.isBoolean(value)) {
        return false;
    }
    var lowercased = lodash_1.toLower(value);
    return lodash_1.isBoolean(value) || (lowercased === 'false' || lowercased === 'true');
}
exports.isBooleanString = isBooleanString;
function isFalsyString(value) {
    var falsyValues = ['false', 'undefined', 'null', '0', '', ""];
    var stringValue = lodash_1.toLower(lodash_1.toString(value));
    var isFalsy = falsyValues.includes(stringValue);
    return (lodash_1.isBoolean(value) && !value) || isFalsy;
}
exports.isFalsyString = isFalsyString;
function toBoolean(value) {
    if (!value) {
        return false;
    }
    var parseBoolConfig = {
        true: true,
        yes: true,
        y: true,
        on: true,
        false: false,
        no: false,
        n: false,
        off: false,
    };
    return !isNaN(value) && lodash_1.isNumber(value)
        ? value > 0
        : parseBoolConfig[lodash_1.trim(lodash_1.toString(value).toLowerCase())];
}
exports.toBoolean = toBoolean;
